// Possible actions to take on those shareable items within the open item modal
export enum OpenItemModalAction {
    SELECT = 'select',
    EDIT = 'edit',
    DELETE = 'delete',
}
